<!--
  Component is used from plugin. Check 'NumberInfoModal.plugin.js' for details.

  TODO: On rewrite do not use variants as wrapper classes but use the theme colors for different variants by default.
-->

<template>
  <b-modal
    ref="infoModal"
    :size="size"
    :title="title"
    :dialog-class="variant"
    centered
    hide-header-close
    no-close-on-backdrop >

    <template slot="modal-header">
      <SBIcon
        v-if="variant === 'danger'"
        class="mr-2"
        :icon="SBIconList.ERROR"
        :color="SBColors.redPrimary"
        :size="12" />
      <h5>{{ title }}</h5>
    </template>

    <div>
      <p>{{ message }}</p>
    </div>

    <template slot="modal-footer">
      <b-button
        @click="hide">
        <span>{{ cancelButtonText }}</span>
        <div class="loader-15 black" />
      </b-button>
      <b-button
        v-if="onConfirmCallback"
        variant="primary"
        :class="[variant]"
        @click="confirm">
        <span>{{ confirmButtonText }}</span>
        <div class="loader-15 black" />
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { ModalSize, ModalVariant } from '@/helpers/enums/modal.enum';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'NumberInfoModalComponent',
  components: {
    SBIcon,
  },
  data() {
    return {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      title: '',
      message: '',
      variant: ModalVariant.INFO,
      size: ModalSize.LARGE,
      onConfirmCallback: () => {},
      SBColors,
      SBIconList,
    };
  },
  beforeMount() {
    this.$numberInfoModalEventBus.$on('show', (params) => {
      this.show(params);
    });
  },
  methods: {
    show(params) {
      this.title = params.title || params.type;
      this.message = params.message || 'Error';
      if (typeof params.confirmCallback === 'function') {
        this.onConfirmCallback = params.confirmCallback;
      } else {
        this.onConfirmCallback = null;
      }
      this.size = params.size || ModalSize.LARGE;
      this.variant = params.variant || ModalVariant.INFO;
      this.confirmButtonText = params.confirmButtonText || 'Confirm';
      this.cancelButtonText = params.cancelButtonText || 'Cancel';
      this.$refs.infoModal.show();
    },
    hide() {
      this.$refs.infoModal.hide();
    },
    confirm() {
      this.onConfirmCallback();
      this.hide(false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal {
  .modal-content {
    border-radius: 10px !important;
  }

  .modal-header {
    padding: 20px !important;
    justify-content: flex-start !important;
    align-items: center !important;

    h5 {
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1 !important;
    }
  }

  .modal-body {
    padding: 20px !important;

    & * {
      font-size: 14px !important;
      line-height: 1.2;
    }
  }

  .modal-footer {
    button {
      border-radius: 10px;

      &.btn-secondary {
        border: solid 1px $greyBorder;
      }
    }
  }

  .modal-dialog {
    &.danger {
      .modal-footer .btn.danger {
        background-color: $redPrimary !important;
        border-color: $redPrimary !important;
      }
    }
  }
}
</style>
